import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Flex, Image, Text } from 'rebass/styled-components';

import Loading from '../../components/molecules/LoadingFullPage';
import BlankLayout from '../../components/layout/Blank';
import NoAccess from '../NoAccess';
import { SignUp } from './steps/signUp';
import { Profile } from './steps/profile';
import { useOnboarding } from './hooks/useOnboarding';

export const Onboarding = () => {
  const { activeNetwork, networks, path, isLoadingUpdateUser, setOnboardingComplete } = useOnboarding();

  if (!activeNetwork) {
    return <Loading />;
  }

  if (!Object.values(networks).some((n) => n.isManager || n.isOrganizationManager)) {
    return <NoAccess />;
  }

  return (
    <BlankLayout>
      <Flex flexDirection="column" px="16px" width="100%" maxWidth="432px" my="0" mx="auto" sx={{ gap: '32px' }}>
        <Flex width="100%" alignItems="center" sx={{ gap: '16px' }}>
          <Image
            width="64px"
            height="64px"
            src={activeNetwork.logoUrl}
            alt={activeNetwork.name}
            sx={{ flex: '0 0 auto' }}
          />
          <Text fontSize="22px" fontWeight="bold" color="text.dark">
            {`Join the ${activeNetwork.name} network`}
          </Text>
        </Flex>
        <Switch>
          <Route exact path={path}>
            <SignUp />
          </Route>
          <Route exact path={`${path}/profile/:mode`}>
            <Profile isLoadingUpdateUser={isLoadingUpdateUser} setOnboardingComplete={setOnboardingComplete} />
          </Route>
        </Switch>
      </Flex>
    </BlankLayout>
  );
};
